import { COLOR_CLASSNAMES } from '@/constants/color'

import type { Enum } from '@/types/Enum'
import type { Priority, Status } from '@/types/task/Task'

export const STATUS_NAMES: Array<Enum> = [
  {
    id: 'todo',
    title: 'To do',
    display: 'to do',
  },
  {
    id: 'in_progress',
    title: 'In progress',
    display: 'in progress',
  },
  {
    id: 'in_review',
    title: 'In review',
    display: 'in review',
  },
  {
    id: 'completed',
    title: 'Completed',
    display: 'completed',
  },
  {
    id: 'canceled',
    title: 'Canceled',
    display: 'canceled',
  },
]

export const STATUS_COLOR_CLASSNAMES: Record<Status, string> = {
  todo: COLOR_CLASSNAMES['zinc-light'],
  in_progress: COLOR_CLASSNAMES['amber-light'],
  in_review: COLOR_CLASSNAMES['green-light'],
  completed: COLOR_CLASSNAMES['blue-light'],
  canceled: COLOR_CLASSNAMES['red-light'],
}

export const STATUS_NAME_MAP: Record<Status, string> = {
  todo: 'To do',
  in_progress: 'In progress',
  in_review: 'In review',
  completed: 'Completed',
  canceled: 'Canceled',
}

export const PRIORITY_NAMES: Array<Enum> = [
  {
    id: 'low',
    title: 'Low',
    display: 'low priority',
  },
  {
    id: 'medium',
    title: 'Medium',
    display: 'medium priority',
  },
  {
    id: 'high',
    title: 'High',
    display: 'high priority',
  },
]

export const PRIORITY_NAME_MAP: Record<Priority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
}
